<template>
  <div class="helpRequestBtn" :class="elementClass">
    <MyModal
      v-if="showDuplicateModal"
      :viewModal="showDuplicateModal"
      typeModal="duplicateTicketWarning"
      :valueModal="duplicateModalPayload"
      @close="handleCloseModal"
      @confirm="handleProceedAfterWarning"
    />
    <span @click="handleClick" :aria-disabled="isCheckingDuplicate">
      <div>
        <span class="material-icons">{{ icon }}</span>
      </div>
      <div>
        <span style="margin-left: 5px">{{ label }}</span>
      </div>
    </span>
  </div>
</template>

<style scoped>
.helpRequestBtn {
  font-family: OpenSansBold;
  min-width: 100px;
  text-align: center;
  font-size: 1rem;
  padding: 12px;
  border-radius: 4px;
  margin: 0 auto;
  cursor: pointer;
}

.helpRequestBtn:hover {
  background-color: #cfd6de;
  opacity: 0.8;
}
.helpRequestBtn a {
  color: #002e5f;
}

@media screen and (max-width: 960px) {
  .helpRequestBtn {
    margin: 0;
    width: 33%;
  }
}
</style>

<script>
import MyModal from "@/components/MyModal.vue";
import { checkDuplicateTicketForAsset } from "@/services/TicketService.js";

export default {
  name: "helpRequestBtn",
  components: {
    MyModal,
  },
  props: {
    url: String,
    icon: String,
    label: String,
    elementClass: String,
    componentName: String,
    assetType: String,
    itemId: [String, Number],
    ticketCategory: {
      type: String,
      default: null,
    },
    skipDuplicateWarning: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDuplicateModal: false,
      duplicateTickets: [],
      pendingNavigationParams: null,
      isCheckingDuplicate: false,
    };
  },
  computed: {
    resolvedTicketCategory() {
      const rawCategory = this.ticketCategory
        ? this.ticketCategory
        : this.componentName &&
          this.componentName.toLowerCase().includes("changerequest")
        ? "change_request"
        : "incident";

      return String(rawCategory)
        .trim()
        .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
        .replace(/[\s-]+/g, "_")
        .replace(/__+/g, "_")
        .toLowerCase();
    },
    duplicateModalPayload() {
      return {
        duplicateTicketLinks: this.duplicateTickets,
        ticketCategory: this.resolvedTicketCategory,
        assetType: this.assetType,
      };
    },
    requestHeaders() {
      const token = this.$keycloak?.idToken;
      const headers = { Accept: "application/json" };
      if (token) {
        headers.Authorization = "Bearer " + token;
      }
      return headers;
    },
  },
  methods: {
    async handleClick() {
      if (this.isCheckingDuplicate) {
        return;
      }

      const params = {
        asset_type: this.assetType,
      };

      if (this.itemId) {
        params.asset_id = this.itemId;
      }

      if (this.skipDuplicateWarning) {
        this.navigateToForm(params);
        return;
      }

      if (!params.asset_id || !this.resolvedTicketCategory) {
        this.navigateToForm(params);
        return;
      }

      this.isCheckingDuplicate = true;

      try {
        const response = await checkDuplicateTicketForAsset(
          this.assetType,
          params.asset_id,
          this.resolvedTicketCategory,
          this.requestHeaders
        );

        const data = response?.data || {};
        const duplicateIds = Array.isArray(data.duplicateTicketIds)
          ? data.duplicateTicketIds
          : data.duplicated
          ? [data.duplicated]
          : [];
        const isDuplicated = data.isDuplicated ?? false;
        const shouldWarn = isDuplicated || duplicateIds.length > 0;

        if (shouldWarn) {
          this.duplicateTickets = duplicateIds.length
            ? duplicateIds.map((ticketId) => ({
                id: ticketId,
                to: this.buildTicketDetailPath(ticketId),
              }))
            : [];
          this.pendingNavigationParams = params;
          this.showDuplicateModal = true;
          return;
        }
      } catch (error) {
        console.error("Duplicate ticket check failed", error);
      } finally {
        this.isCheckingDuplicate = false;
      }

      this.navigateToForm(params);
    },
    navigateToForm(params) {
      this.$router.push({
        name: this.componentName + this.$i18n.locale,
        params,
      });
    },
    handleCloseModal() {
      this.showDuplicateModal = false;
      this.pendingNavigationParams = null;
      this.duplicateTickets = [];
    },
    handleProceedAfterWarning() {
      const params = this.pendingNavigationParams;
      this.showDuplicateModal = false;
      this.pendingNavigationParams = null;
      this.duplicateTickets = [];
      if (params) {
        this.navigateToForm(params);
      } else {
        this.navigateToForm({
          asset_type: this.assetType,
          asset_id: this.itemId,
        });
      }
    },
    buildTicketDetailPath(ticketId) {
      const detailSegment = this.$t("nav.detail");

      if (this.resolvedTicketCategory === "change_request") {
        return `/${this.$t("nav.crListUrl")}/${detailSegment}/${ticketId}`;
      }

      return `/${this.$t("nav.incidentListUrl")}/${detailSegment}/${ticketId}`;
    },
  },
};
</script>
